__turbopack_context__.v({
  "address": "style-module-scss-module__AHlrTa__address",
  "component": "style-module-scss-module__AHlrTa__component",
  "disclaimer": "style-module-scss-module__AHlrTa__disclaimer",
  "footer": "style-module-scss-module__AHlrTa__footer",
});
